import * as React from "react";
import { useId, useState } from "react";

import EyeIcon from "./EyeIcon";

type PasswordInputProps = {
  id?: string;
  label?: React.ReactNode;
  placeholder?: string;
  value?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  name?: string;
  autoComplete?: string;
  required?: boolean;
  className?: string;
};

export default function PasswordInput({
  id,
  label,
  placeholder,
  value,
  onChange,
  name,
  autoComplete,
  required,
  className = "",
}: PasswordInputProps) {
  const autoId = useId();
  const inputId = id || `password-${autoId}`;
  const [visible, setVisible] = useState(false);

  return (
    <div className={`pis-field ${className}`.trim()}>
      {label ? (
        <label className="pis-label" htmlFor={inputId}>
          {label}
        </label>
      ) : null}

      <div className="pis-inputWrap">
        <input
          id={inputId}
          name={name}
          className="pis-input pis-input--withIcon"
          type={visible ? "text" : "password"}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          autoComplete={autoComplete}
          required={required}
        />

        <button
          type="button"
          className="pis-iconBtn"
          onClick={() => setVisible((v) => !v)}
          aria-label={visible ? "Hide password" : "Show password"}
        >
          <EyeIcon open={visible} className="pis-eye" />
        </button>
      </div>
    </div>
  );
}
